

import {
    ALL_OAUTH_COMPANIES
} from "../constant/ActionType";

export default function AllOAuthCompanyDataRed(state = {
    alloauthcompanydata: [],
}, action) {
    switch (action.type) {
        case ALL_OAUTH_COMPANIES:
            return {
                ...state,
                alloauthcompanydata: action?.data,
                lastPage: action?.data?.data?.last_page
            };

        default:
    }

    return state;
}
